import { makeAutoObservable } from 'mobx';
import services from '../services';
import { awareGoTheme } from '../theme';
import { extractErrorMessage, querystring } from '../utils/helpers';

class CompanyStore {
    companyId =
        parseInt(querystring('o', window.location.search)) ||
        parseInt(window.localStorage.getItem('companyId'));
    companies = [];
    loadingCompanies = false;
    noCompanies = false;
    haveAdminRights = false;
    currentCompany = null;
    error = null;

    constructor() {
        makeAutoObservable(this);
    }

    logout = () => {
        this.companies.replace([]);
        this.currentCompany = null;
        this.companyId = null;
        this.haveAdminRights = false;
        this.loadingCompanies = false;
        window.localStorage.removeItem('companyId');
    };

    async loadCompanies() {
        this.loadingCompanies = true;
        this.error = null;
        this.companies.clear();
        try {
            const result = await services.Companies.myCompanies();
            this.companies.replace(result.companies);
            this.noCompanies = this.companies.length === 0;
            if (this.companies.length > 0)
                this.setCurrentCompany(
                    this.companyId || this.companies[0].company_id
                );
            this.haveAdminRights = result.haveAdminRights;
        } catch (e) {
            this.error = extractErrorMessage(e);
        } finally {
            this.loadingCompanies = false;
        }
    }

    setCurrentCompany(company_id) {
        company_id = parseInt(company_id);
        let company = this.companies.find((x) => x.company_id === company_id);
        if (!company && this.companies.length > 0) company = this.companies[0];
        if (company) {
            this.currentCompany = company;
            window.localStorage.setItem('companyId', company_id);
        }
    }

    get theme() {
        return {
            primary: this.currentCompany
                ? this.currentCompany.color_main
                    ? this.currentCompany.color_main
                    : awareGoTheme.primary
                : awareGoTheme.primary,
        };
    }
}

export default CompanyStore;
